<template>
    <v-container fill-height class="align-start py-3">
        <loading-overlay :loading="loading"></loading-overlay>

        <v-row class="fill-height align-center">
            <v-col class="text-center" v-if="match">
                <transfer
                    :transfer="match"
                    style="width: 100%;"
                    :cancelledCountInLast30Days="10"
                    @open-make-payment="openMakePayment"
                    @validateTransaction="validateTransaction"
                    @loading="loading = true"
                    @loaded="loading = false"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import transfer from '../transfer.vue';
import pisErrorDialog from '../transfers/components/pis-error-dialog.vue';

export default {
    components: {
        transfer,
    },
    data() {
        return {
            loading: true,
            match: null,
        };
    },
    mounted() {
        this.load();
    },
    computed: {
        paymentNotReceivedMessage() {
            return `<ul class="v-card__text" style="text-align: left;">
              <li>Please make sure you sent complete payment to the correct account.</li>
              <li>However, if you made complete payment to the correct account, then perhaps your payment is still processing and is yet to be received.</li>
              <li>If this error still persists after two hours and you made complete payment to the correct account, then please contact help & support for assistance.</li>
              <li>Note that payments made on weekends (Saturday and Sunday) may not process till the next Monday.</li>
              <li>If you accidentally made incomplete payments, overpayments, or made payments to the wrong account, then quickly contact help & support for assistance.</li>
              <br>
              <p>Thank you<p>
            </ul>`;
        },
    },
    methods: {
        async load() {
            const { id, hash } = this.$route.params;

            try {
                const { data } = await Vue.backendApi().unregisteredPaymentRequest(id, hash).fetch();
                const {
                  match,
                  order,
                } = data;

                match.order = order;
                Vue.set(this, 'match', match);
            } catch (err) {
                this.$swal({
                    type: 'error',
                    title: 'Error',
                    text: err,
                });
            } finally {
                this.loading = false;
            }
        },

        openMakePayment() {
            const { id, hash } = this.$route.params;
            this.$router.push({
                name: 'upr-make-payment',
                params: {
                    id,
                    hash,
                },
            });
        },

        validateTransaction() {
            const { id, hash } = this.$route.params;
            this.loading = true;

            Vue.backendApi().unregisteredPaymentRequest(id, hash).validateTransaction(this.match.id)
                .then((response) => {
                    this.loading = false;

                    const {
                        matcher_payment_completed_at: matcherPaymentCompletedAt,
                        probably_paid: probablyPaid,
                        type,
                    } = response.data;

                    if (matcherPaymentCompletedAt) {
                      this.$swal({
                          type: 'success',
                          title: 'Payment received',
                          text: this.getPaymentReceivedMessage(this.match),
                      });
                    } else {
                      this.$swal({
                          type: 'error',
                          title: 'Payment not received yet',
                          html: this.paymentNotReceivedMessage,
                      });
                    }
                })
                .catch((err) => {
                  this.loading = false;

                  const error = err.toUpperCase();
                  if (error === 'PAYMENT_NOT_RECEIVED') {
                      this.$swal({
                          type: 'error',
                          title: 'Payment not received yet',
                          html: this.paymentNotReceivedMessage,
                      });
                  } else if (error === 'PAYMENT_RECEIVED') {
                      this.$swal({
                          type: 'success',
                          title: 'Payment Received',
                          text: this.getPaymentReceivedMessage(this.match),
                      });
                  } else if (error === 'PB_BANK_IS_DOWN' || error === 'MATCHER_BANK_IS_DOWN') {
                      this.$swal({
                          type: 'warning',
                          customContainerClass: 'sad-face',
                          title: 'Oops! Bank Connection Is Down!',
                          text: `Sorry we are unable to confirm the receipt of
                              your payment at this time. Our bank connection is
                              down at this time. However, you need not to worry or
                              do anything extra. As soon as we re-establish connection,
                              we would confirm your payment and notify you of the
                              completion of this transaction. Please bear with us.
                              Thank you.`,
                      });
                  } else {
                      this.$swal({
                          type: 'warning',
                          title: err,
                      });
                  }
              });
        },

        getPaymentReceivedMessage(match) {
            const { matcherRecipient } = match;
            if (!matcherRecipient) {
                return null;
            }

            if (!matcherRecipient.recipient) {
                return null;
            }

            const { recipientInfo } = matcherRecipient.recipient;
            if (!recipientInfo) {
                return null;
            }

            const {
                name,
                payment_type: paymentType,
            } = recipientInfo;

            const paymentTypeId = paymentType ? paymentType.id : null;
            let destination;
            if (paymentTypeId === 1) {
                destination = 'bank account';
            }
            if (paymentTypeId === 3) {
                destination = 'mobile money account';
            }

            return `Congratulations! Now we have confirmed receipt of your payment,
                ${match.poster_currency} ${this.$options.filters.currency(match.poster_amount)}
                will be deposited into ${name}'s ${destination}.
                This transfer will be completed within 24 hours. Thank you.`;
        }
    },
};
</script>
